<template>
  <vs-tabs :value="0">
    <vs-tab :label="getTags[0]">
      <div>
        <search-nav @handleSearch="handleSearch">
          <search-nav-item-field label="키워드" v-model="table.keyword" @keyupEvent="handleInput" />
        </search-nav>

        <div class="flex mb-4" style="justify-content: flex-end">
          <vs-button class="" color="secondary" @click="onClickNew"> 신규작성 </vs-button>
        </div>
        <vs-card>
          <vs-table stripe ref="table" :sst="true" :max-items="table.perPage" :data="table.list" :noDataText="$t('approval.데이터가 없습니다')" @selected="handleItemClickDetail">
            <template slot="thead">
              <vs-th style="width: 80px"><span class="w-full text-center">No.</span></vs-th>
              <vs-th style="min-width: 130px"
                ><span class="w-full text-center">{{ tabName }}명</span></vs-th
              >
              <vs-th style="min-width: 130px"><span class="w-full text-center">담당주무관</span></vs-th>
              <vs-th style="min-width: 130px">
                <span class="w-full text-center">{{ tabName }}주소</span>
              </vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="tr.id" class="text-center">{{ total - currentPage * table.perPage + (table.perPage - indextr) }}</vs-td>
                <vs-td :data="tr.field_name" class="text-center">{{ tr.field_name }}</vs-td>
                <vs-td class="text-center">{{ tr.manager_name }}</vs-td>
                <vs-td class="text-center">{{ tr.address }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>

          <div class="vs-con-table">
            <div class="con-pagination-table vs-table--pagination">
              <k-pagination :total="lastPage ? lastPage : 1" v-model="currentPage" @change="handleChangePage"></k-pagination>
            </div>
          </div>
        </vs-card>
      </div>
    </vs-tab>
    <vs-tab :label="getTags[1]" @click="onClickTab(1)"></vs-tab>
  </vs-tabs>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav";
import SearchNavItemProject from "@/components/nav/SearchNavItemProject";
import KPagination from "@/components/kPagination/kPagination";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import SearchNavItemField from "@/components/nav/SearchNavItemField";
export default {
  name: "FieldList",
  components: {
    SearchNavItemField,
    SearchNavItemKeyword,
    KPagination,
    SearchNavItemProject,
    SearchNav,
  },
  data() {
    return {
      // 검색 네비게이션
      nav: {
        projectId: "",
        date: ["", ""],
        keyword: "",
        type: "",
        typeList: [],
        orderTarget: "created_at",
        orderDirection: "desc",
        searchTypes: [
          { text: "제목", value: "content$title" },
          { text: "작성자", value: "content$writer" },
        ],
        searchType: "content$title",
      },

      currentPage: 1,
      lastPage: 1,
      total: 0,
      table: {
        list: [],
        perPage: 15,
        keyword: "",
      },

      // 마지막 api 호출시 사용한 옵션
      apiLastLoadOptions: null,
    };
  },
  created() {
    this.initBreadcrumb();
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    tabName() {
      if (`${this.projectId}` === "2") {
        return "현업부서";
      }
      return "사업장";
    },
    getTags() {
      if (`${this.projectId}` === "2") {
        return ["부서 등록", "부서 현황"];
      }
      return ["사업장 등록", "사업장 현황"];
    },
  },
  mounted() {
    this.loadFieldList();
  },
  methods: {
    initBreadcrumb() {
      if (`${this.projectId}` === "2") {
        this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "부서 현황" }, { title: "부서", active: true }]);
        return;
      }
      this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "사업장 현황" }, { title: "직영사업장", active: true }]);
    },
    async loadFieldList() {
      const projectId = this.projectId;
      const page = this.currentPage;
      const perPage = this.table.perPage;
      const keyword = this.table.keyword;
      const code = "workplace-insider";

      const options = { projectId, code, keyword, page, perPage }
      if (JSON.stringify(options) === JSON.stringify(this.apiLastLoadOptions)) {
        // 이전과 동일한 옵션으로 리스트를 불러옵니다.
        return;
      }
      this.apiLastLoadOptions = JSON.parse(JSON.stringify(options));
      await this.$store.dispatch("project/LOAD_FIELD_LIST", options);
      const fieldListInfo = this.$store.state.project.fieldListInfo;
      this.table.list = fieldListInfo.data;

      this.currentPage = fieldListInfo.current_page;
      this.lastPage = fieldListInfo.last_page;
      this.total = fieldListInfo.total;
    },
    onClickTab(tabIndex) {
      if (tabIndex === 1) {
        const proj_id = this.$route.params.proj_id;
        const type = this.$route.query.type;
        if (type) this.$router.push({ name: "field-info-type", params: { proj_id, type } });
        else this.$router.push({ name: "field-workplace-info" });
      }
    },
    onClickSearch() {
      this.loadList();
    },
    onClickSort(sortKey, asc) {
      this.sortKey = sortKey;
      this.asc = asc;
    },
    onChangePage(page) {
      this.page = page;
    },
    onClickDownload() {
      this.popup.excel = true;
    },
    onClickNew() {
      const type = this.$route.query.type;
      this.$router.push({ name: "field-workplace-create", query: { type } });
    },
    onClickClose() {
      const keys = Object.keys(this.popup);
      keys.map((key) => {
        this.popup[key] = false;
      });
    },
    onClickDetail(value, target) {},

    handleItemClickDetail(data) {
      this.$router.push({ name: "field-workplace-update", params: { proj_id: this.$route.params.proj_id, postId: data.id } });
    },

    handleChangePage(page) {
      this.currentPage = page;
      this.loadFieldList();
    },
    // 사업장 검색 폼에서 Enter 키가 눌렸을 때
    handleInput(data) {
      this.table.keyword = data;
      this.handleSearch();
    },
    // "검색" 버튼이 클릭됐을 때
    handleSearch() {
      this.loadFieldList();
    },
    comma(str) {
      return `${str}`.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style scoped></style>
